export enum EUserRole {

    Gestionnaire = 1,
    Technicien = 2
}
